export { default } from './OrderDetails';
export type { OrderDetailsProps } from './OrderDetails';
